import { Button } from "@/components/ui/button";

export const UpsellSection = ({ data, onAccept, onDecline }: any) => {
    return (
        <div className="py-12 px-4 bg-amber-50 border-y border-amber-100">
            <div className="max-w-3xl mx-auto text-center">
                <div className="text-amber-600 font-bold mb-2">عرض خاص!</div>
                <h2 className="text-3xl font-bold mb-4">{data.title || "Wait! Special Offer"}</h2>
                <p className="text-lg mb-8">{data.description}</p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Button size="lg" onClick={onAccept} className="bg-amber-600 hover:bg-amber-700">
                        {data.acceptText || "Yes, Add to Order"} - {data.price}
                    </Button>
                    <Button variant="ghost" onClick={onDecline}>
                        {data.declineText || "No, thanks"}
                    </Button>
                </div>
            </div>
        </div>
    );
};
